import * as constants from '@config/constants';

const initialState = {
  confirmationCode: '',
  email: '',
  password: '',
  passwordConfirm: '',
};

const reducer = (state = initialState, action) => {
  const { data } = action;
  switch (action.type) {
    case constants.SIGN_IN:
      return {
        ...state,
        user: data,
      };
    case constants.SIGN_OUT:
      return { ...state, user: null };
    case constants.UPDATE_PROFILE:
      return { ...state, user: data };
    default:
      return state;
  }
};

export default reducer;
